/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "SK",
  title: "Hi! all, I'm SurrajKumar",
  subTitle: emoji(
    "Enthusiastic AI/ML Engineer with a strong foundation in building and deploying machine learning models. Proficient in Python and popular deep learning frameworks like TensorFlow and PyTorch. Eager to leverage these skills to tackle real-world problems and contribute to the advancement of AI."
      ),
  resumeLink:
    "https://drive.google.com/file/d/152r9GbG9NgwtLV-uCVoxISW7cAR2K6kB/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/SurrajKumar2000",
  linkedin: "https://linkedin.com/in/surrajkumar-prabhu",
  gmail: "surrajkumar2000@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY AI/ML DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Developed highly interactive ML/DL models"
    ),
    emoji(
    	"⚡ Teaching Associate - AI"
    ),
    emoji(
    	"⚡ Research Assistant - DL"
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-github-alt"
    },
    /* {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
   {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },*/
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "California State University, Fullerton",
      logo: require("./assets/images-1/csuflogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "August 2022 - May 2024",
      desc: "Ranked top 10% in the program | Participated in the research of medical and thermodynamics related AI/ML techniques and published 3 papers.",
      descBullets: [
        "Advanced Database Management System | Advanced Computer Networks | Artificial Intelligence | Mobile application Development | Advanced Blockchain Technology",
      ]
    },
    {
      schoolName: "Anna University",
      logo: require("./assets/images-1/annaunivlogo.png"),
      subHeader: "Bachelor of Technology in Information Technology",
      duration: "August 2018 - June 2022",
      desc: "Ranked top 10% in the program.",
      descBullets: ["Object Oriented programming | Data Structures & Algorithm | Software Engineering"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Machine Learning Frameworks & Libraries", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Mathematics & Statistics",
      progressPercentage: "70%"
    },
    {
      Stack: "Cloud Platforms for AI/ML",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "AI Consulatant in Training",
      company: "Chambers Capital Ventures",
      companylogo: require("./assets/images-1/CCVlogo.png"),
      date: "March 2023 – Present",
      desc: "Collaborate with portfolio companies to identify AI opportunities and develop tailored AI roadmaps."
         },
    {
      role: "Research Assistant",
      company: "California State University, Fullerton",
      companylogo: require("./assets/images-1/csuflogo.png"),
      date: "December 2023 – Present",
      desc: "Developed 95% accurate ANN model for power generation storage, reducing design reliance by 40% through data analysis and LSTM architecture."
       },
    {
      role: "Teaching Associate",
      company: "California State University, Fullerton",
      companylogo: require("./assets/images-1/csuflogo.png"),
      date: "December 2023 - Present",
      desc: "Empowered 50+ students to excel in AI through collaborative lectures, fostering problem-solving and data science application skills."
       },
        {
      role: "AI/ML Engineer",
      company: "Indian Servers",
      companylogo: require("./assets/images-1/indianserverslogo.png"),
      date: "May 2022 – August 2022",
      desc: "Responsible for developing an AI-powered medical diagnosis tool boosting accuracy (90%+) in diabetes & skin cancer prediction while saving doctors 30% time."

    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/pro-1.png"),
      projectName: "Retail store Q&A System: An LLM-Powered DB Integration with Langchain",
      projectDesc: "An end-to-end Q&A system for a retail t-shirt store using large language models and the Langchain framework. The system will be able to interact with MySQL DB to retrieve and synthesize information to answer user queries.",
footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/SurrajKumar2000/LLM-DressShop"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/colon.png"),
      projectName: "Lung-and-Colon-Cancer-prediction-using-CNN",
      projectDesc:"Developed a deep learning model by detailed study of various algorithms including AlexNet, DenseNet and XceptionNet. With an accuracy of 90%+ built a web based application using Django framework.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/SurrajKumar2000/Lung-and-Colon-Cancer-prediction-using-CNN"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/loan.png"),
      projectName: "Data-Driven Loan Prediction System with AWS & ML",
      projectDesc: "Developed 85% accurate loan prediction model using PySpark on EMR for AWS Bank Prospect System, improving efficiency by 20% with interactive visualizations in Tableau and PowerBI.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/SurrajKumar2000/Data-Driven-Loan-Prediction-System-with-AWS-ML"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images-1/diabetes.png"),
      projectName: "Diabetes-Prediction-System",
      projectDesc: "Predict whether a person suffers from diabetes or not based on various features like insulin level,glucose level,age,BMI. In this process ,we will perform all the steps from Data gathering to Model deployment. Here we have used logistic regression to predict the accuracy.Then we create a web app using Django which is a python framework.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/SurrajKumar2000/Diabetes-Prediction-System"
        }
        //  you can add extra buttons here.
      ]
    },
    //{
    //  image: require("./assets/images/nextuLogo.webp"),
    //  projectName: "Nextu",
    //  projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //  footerLink: [
    //   {
    //      name: "Visit Website",
    //      url: "http://nextu.se/"
    //    }
    //  ]
    //}
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Azure AI-900 Certification",
      subtitle:"This certificate validates my foundational knowledge of AI concepts, Azure AI services, machine learning models, data preparation/processing, and best practices for AI.",
      image: require("./assets/images-1/Aicert.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url:"https://learn.microsoft.com/api/credentials/share/en-us/SurrajKumar-7750/E50836FFDC96CFB7?sharingId=E96D6825B0D184FB"
        },
       // {
         // name: "Award Letter",
       //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
       // },
        //{
        //  name: "Google Code-in Blog",
       //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
       // }
      ]
    },
    {
      title: "Smart India Hackathon",
      subtitle:"Developed a Calibration Curve for Typical Joints - Finalist", 
      image: require("./assets/images-1/sih.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
         name: "View Site",
         url: "https://www.sih.gov.in/"
       }
      ]
    },

    {
      title: "Nika Nikopour Foundation Awardee",
      subtitle: "Received nika nikopour scholarship award for academic excellence",
      image: require("./assets/images-1/nika.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "View Site", url: "https://nikanikopourfoundation.org/"},
        //{
        //  name: "Final Project",
         // url: "https://pakistan-olx-1.firebaseapp.com/"
        //}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Publications",
    subtitle:
      "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
   displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://www.opastpublishers.com/table-contents/ijcrt-volume-8-issue-4-year-2023",
      title: "Predicting Lung Cancer Survivability: A Machine Learning Ensemble Method On Seer Data",
      description:
        "International Journal of Research and Cancer Therapy |10.33140/IJCRT.08.04.03| November 2023"
    },
    {
      url: "https://www.ijeast.com/papers/55-59,%20Tesma0805,IJEAST.pdf",
      title: "Advances in early detection of optical neuritis diagnosis systems",
      description:
        "International Journal of Engineering Applied Sciences and Technology |10.33564/IJEAST.2023.v08i05.007| September 2023"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "surrajkumar2000@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};